import React from 'react';

const PredictiveURL = () => {
    return (
        <div style={{ width: '100%', height: '100vh' }}>
            <iframe
                src="https://predictive.buoyantworx.com"
                style={{ width: '100%', height: '100%', border: 'none' }}
                title="Predictive Dashboard"></iframe>
        </div>
    );
};

export default PredictiveURL;
